
import { initializeApp } from 'firebase/app';
import { getAuth, PhoneAuthProvider, PhoneMultiFactorGenerator, RecaptchaVerifier } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDQeGbap0ZUuKZP-J2YPEXpmuTdU45Aub0",
  authDomain: "kanish-infotech.firebaseapp.com",
  projectId: "kanish-infotech",
  storageBucket: "kanish-infotech.firebasestorage.app",
  messagingSenderId: "331442301937",
  appId: "1:331442301937:web:052782b7576a6575ee3250",
  measurementId: "G-C247058KGV"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, PhoneAuthProvider, PhoneMultiFactorGenerator, RecaptchaVerifier };